import { AsyncLocalStorage } from 'node:async_hooks'
import type { ODataResponseFormat, ODataMetadataLevel } from '../utils/http'

export interface ResolvedODataContext {
  serviceBaseUrl: string
  serveAs: ODataResponseFormat
  metadataLevel: ODataMetadataLevel
}

export interface ResourcefulODataContextResolver {
  (
    fallbackResponseFormat?: ODataResponseFormat,
    fallbackMetadataLevel?: ODataMetadataLevel
  ): Promise<ResolvedODataContext>
}

export interface ResourcefulODataContextStore {
  resolver: ResourcefulODataContextResolver
}

export const ODataContext = new AsyncLocalStorage<ResourcefulODataContextStore>()
